(function () {
  const stickyScrollEffect = () => {
    document.querySelectorAll(".sticky-section").forEach((block) => {
      const box = block.closest("section");
      if (!box) return;

      const stickyEffect = block.dataset.stickyEffect;
      if (!stickyEffect) return;

      const normalElement = box.previousElementSibling;
      if (!normalElement) return;

      const nextElement = box.nextElementSibling;
      const nextElementNext = nextElement?.nextElementSibling;

      if (normalElement._stickyScrollHandler) {
        window.removeEventListener(
          "scroll",
          normalElement._stickyScrollHandler
        );
      }

      setTimeout(() => {
        const viewportHeight = window.innerHeight;
        const sectionHeight = normalElement.offsetHeight;

        let scrollTop = 0;

        if (sectionHeight >= viewportHeight) {
          scrollTop = viewportHeight - sectionHeight;
        }

        normalElement.style.setProperty("--viewport-height", `${scrollTop}px`);
      }, 100);

      normalElement.classList.add("sticky-active");
      nextElement?.classList.add("background");
      nextElementNext?.classList.add("background");

      let isSticky = false;

      const scrollHandler = () => {
        const stickyTop = normalElement.getBoundingClientRect().top;
        const normalElementBottom = box.getBoundingClientRect().top;

        if (stickyTop <= 0 && !isSticky) {
          normalElement.classList.add("sticky-active");
          isSticky = true;
        }

        if (normalElementBottom <= 0 && isSticky) {
          normalElement.classList.remove("sticky-active");
          isSticky = false;
        }
      };

      normalElement._stickyScrollHandler = scrollHandler;

      window.addEventListener("scroll", scrollHandler);

      scrollHandler();
    });
  };

  document.addEventListener("DOMContentLoaded", stickyScrollEffect);

  window.addEventListener("resize", stickyScrollEffect);

  document.addEventListener("shopify:section:load", stickyScrollEffect);
})();
